module.exports = __webpack_public_path__ + "img/img_about.f94bf9b6.png";